var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceHolderImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_48123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108 216C167.647 216 216 167.647 216 108C216 48.3532 167.647 0 108 0C48.3532 0 0 48.3532 0 108C0 167.647 48.3532 216 108 216Z",
    fill: "#AE6F28",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.5 108C215.5 167.371 167.371 215.5 108 215.5C48.6294 215.5 0.5 167.371 0.5 108C0.5 48.6294 48.6294 0.5 108 0.5C167.371 0.5 215.5 48.6294 215.5 108Z",
    stroke: "#AE6F28",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 107.056C120.584 107.056 130.787 96.9056 130.787 84.385C130.787 71.8644 120.584 61.7145 108 61.7145C95.4149 61.7145 85.2129 71.8644 85.2129 84.385C85.2129 96.9056 95.4149 107.056 108 107.056Z",
    fill: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.868 116.502H96.1316C82.3646 116.502 70.9712 127.838 70.9712 141.534C70.9712 144.84 72.3954 147.674 75.2437 149.091C79.5162 151.453 89.0108 154.286 108 154.286C126.989 154.286 136.483 151.453 140.756 149.091C143.129 147.674 145.028 144.84 145.028 141.534C145.028 127.365 133.635 116.502 119.868 116.502Z",
    fill: "#F8F8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_48123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 216,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceHolderImg);
export default __webpack_public_path__ + "static/media/place-holder-img.bfc8a5623688eb06c8834f8440cefd5e.svg";
export { ForwardRef as ReactComponent };